import TourPage from "@/components/TourPage";

export default function Volcanoes7Day() {
  return (
    <TourPage
      tourId="rwanda/volcanoes-7-day"
      title="7 Days Volcanoes National Park Adventure"
      duration="7 Days / 6 Nights"
      price="Contact for price"
      image="/lakevolcanoesrwanda.jpeg"
      description="This 7-day journey, features gorilla trekking, hiking, biking, caving, canoeing, and cultural experiences."
      itinerary={[
        {
          day: 1,
          title:
            "Transfer from Kigali to Musanze for Biking & Boating in Mukungwa River",
          description:
            "Begin your adventure with biking and boating activities.",
          activities: [
            "Depart from Kigali and drive to Musanze",
            "Biking and boating in Mukungwa river",
            "Dinner and camping at Mukungwa trail",
          ],
          accommodation: "Camping at Mukungwa trail",
          meals: "Dinner",
        },
        {
          day: 2,
          title: "Twin Lakes Experience",
          description: "Explore the beautiful Twin Lakes area.",
          activities: [
            "Hike and boat in Twin Lakes",
            "Learn about the history and significance of the lakes",
            "Experience local banana beer making and tasting",
          ],
          accommodation: "Lodge near Twin Lakes",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 3,
          title: "Gorilla Trekking and Gorilla Guardian Village Tour",
          description: "Experience the highlight of Rwanda tourism.",
          activities: [
            "Gorilla trekking in Volcanoes National Park",
            "Visit the Gorilla Guardian Village for a cultural experience",
          ],
          accommodation: "Lodge near Volcanoes National Park",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 4,
          title:
            "Pilgrimage Experience at the Roots of Nyabingi Heritage Center",
          description: "Immerse yourself in local culture and traditions.",
          activities: [
            "Visit the Nyabingi Heritage Center",
            "Experience cultural diversity and traditional beliefs",
            "Enjoy a boat cruise on Twin Lakes",
          ],
          accommodation: "Lodge near Twin Lakes",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 5,
          title: "Birding at Rugezi Marshland and Canoeing at Mukungwa River",
          description: "Explore Rwanda's rich biodiversity.",
          activities: [
            "Birding at Rugezi Marshland",
            "Canoeing in Mukungwa river",
          ],
          accommodation: "Lodge in Musanze",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 6,
          title: "Bisoke Hiking",
          description: "Challenge yourself with a volcano hike.",
          activities: [
            "Hike Bisoke Volcano",
            "Enjoy stunning views and unique flora and fauna",
          ],
          accommodation: "Lodge in Musanze",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 7,
          title: "Musanze Cave and Departure to Kigali",
          description: "Final day of exploration before departure.",
          activities: [
            "Visit Musanze Cave",
            "Depart for Kigali and drop-off at your hotel or airport",
          ],
          meals: "Breakfast",
        },
      ]}
      inclusions={[
        "All park entrance fees and permits",
        "All activities, including gorilla trekking, hiking, biking, caving, and canoeing",
        "All meals (breakfast, lunch, and dinner)",
        "All transportation and airport transfers (4x4 luxury vehicle)",
        "Accommodation for all nights",
        "Professional driver guide",
        "All concession fees",
        "Coffee, soft drinks, snacks, and drinking water (on all days)",
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Personal requirements apart from the included",
        "The government imposed an increase in taxes and/or park fees",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "Tip",
      ]}
    />
  );
}
